import React from 'react'
import styled from 'styled-components'
import * as media from '../media'
import Text from '../text'
import {browserHistory} from 'react-router'
import {compose, lifecycle, withHandlers, withState} from "recompose";
import getImgUrl from '../getImgUrl'
import getUrl from '../getUrl'
import _ from 'lodash'
import Pagination from './pagination'
import queryString from 'query-string'
import TranslateText from 'src/text/modal';
import linkifyHtml from '../linkifyHtml';

const Header = styled.div`
  margin: 40px;
  margin-left:0;
  margin-right:0;
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const Mobile = styled.div`
  ${media.biggerThan(701)`display:none !important;`}
`

const Desktop = styled.div`
  ${media.smallerThan(700)`display:none !important;`}  
`

const PaginationContainer = styled.div`
  justify-content: center;
  ${media.smallerThan(700)`justify-content: center;`}
`

const NewsContainer = styled.div`
  ${media.smallerThan(700)`margin-top: -20px;`}
`

class News extends React.Component {
  render() {
    const {limit, page, total, setPage, fetchDict} = this.props

    return (
      <div>
        <div style={{width: '80%', margin: '0px auto'}}>
          <Header>
            <TranslateText id="news__header" />
          </Header>

          <NewsContainer>
            {
              (this.props.news || []).map(n => {
                return (
                  <New key={n.id} {...n} />
                )
              })
            }
          </NewsContainer>

          <Pagination
            paginationData={{
              maxRows: limit,
              page: page,
              total: total,
            }}
            onPagination={(page) => {
              setPage(page)
              fetchDict({page})
            }}
          />

        </div>
      </div>
    )
  }
}

function New(props) {
  return (
    <React.Fragment>
      <NewDesktop {...props} />
      <NewMobile {...props} />
    </React.Fragment>
  )
}

class NewDesktop extends React.Component {

  render() {
    const startDate = new Date(this.props.start_date);
    return (
      <Desktop
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 30,
        }}
      >
        <div
          style={{
            height: 'auto',
            width: 'auto',
            width: 300,
            height: 300,
            border: '1px solid rgb(225, 225, 225)',
            padding: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={getImgUrl('/media/static/press/' + this.props.image_url)}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
            }}
          />
        </div>
        <div
          style={{
            marginLeft: 20,
            display: 'flex',
            flexDirection: 'column',
            height: 300,
          }}
        >
          <div style={{fontWeight: 600}}>{this.props.name}</div>
          <div
            style={{marginTop: 20}}>{`${startDate.getDate()}.${(startDate.getMonth() < 9 ? '0' : '') + (startDate.getMonth() + 1)}.${startDate.getFullYear()}`}</div>
          <div
            style={{
              marginTop: 20,
              border: '1px solid rgb(225,225,225)',
              padding: 10,
              width: 'calc(80vw - 320px)',
              height: 223,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                maxHeight: '88%',
                overflow: 'hidden',
              }}
              dangerouslySetInnerHTML={{ __html: linkifyHtml(this.props.short_content) }}
            />
            <div
              style={{
                cursor: 'pointer',
                color: '#173DB0',
                marginTop: 'auto'
              }}
              onClick={() => browserHistory.push("/new/" + this.props.id)}
            >
              Подробнее &gt;&gt;
            </div>
          </div>
        </div>
      </Desktop>
    )
  }
}

class NewMobile extends React.Component {
  render() {
    const startDate = new Date(this.props.start_date);
    return (
      <Mobile
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <div style={{fontWeight: 600}}>{this.props.name}</div>
        <div
          style={{marginTop: 10}}>{`${startDate.getDate()}.${(startDate.getMonth() < 9 ? '0' : '') + (startDate.getMonth() + 1)}.${startDate.getFullYear()}`}</div>
        <div
          style={{
            height: 'auto',
            width: 'auto',
            width: '100%',
            height: 300,
            border: '1px solid rgb(225, 225, 225)',
            padding: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10
          }}
        >
          <img
            src={getImgUrl('/media/static/press/' + this.props.image_url)}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              margin: 'auto',
            }}
          />
        </div>

        <div
          style={{
            marginTop: 20,
            border: '1px solid rgb(225,225,225)',
            padding: 10,
            width: '100%',
            minHeight: 200,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: linkifyHtml(this.props.short_content)}} />
          <div
            style={{
              cursor: 'pointer',
              color: '#173DB0',
              marginTop: 'auto',
            }}
            onClick={() => browserHistory.push("/new/" + this.props.id)}
          >
            Подробнее &gt;&gt;
          </div>
        </div>
      </Mobile>
    )
  }
}

const enhance = compose(
  withState('limit', 'setLimit', 10),
  withState('page', 'setPage', 0),
  withState('loading', 'setLoading', false),
  withState('total', 'setTotal', 0),
  withState('news', 'setNews', 0),

  withHandlers({
    fetchDict: props => ({url, limit, page, filters, isCurrent, ...rest}) => {
      let limitFound = limit || props.limit
      let pageFound = page == 0 ? page : (page || props.page)
      let addition = queryString.stringify({
        is_current: true,
        limit: limitFound,
        page: pageFound,
        press_type_id: 18442,
      })
      props.setLoading(true)
      fetch(getUrl(`/api/v1/dictionaries/fw/press/?${addition}`))
        .then(data => {
          return data.json()
        }).then(response => {
        props.setLoading(false)
        props.setNews(_.get(response, 'data.data'))
        props.setLimit(_.get(response, 'data.pagination.limit'))
        props.setPage(_.get(response, 'data.pagination.page'))
        props.setTotal(_.get(response, 'data.pagination.total'))
      }).catch(err => {
        console.log(err)
        props.setLoading(false)
      })
    },
  }),

  lifecycle({
    componentDidMount() {
      this.props.fetchDict({})
    }
  }),
)

export default enhance(News)



// WEBPACK FOOTER //
// ./src/pages/news.js